import { IProvider } from "@u4i/modules/Admin/modules/Providers/interfaces";
import Parser from "@u4i/utils/Parser";

export const AdminProviderParser = new Parser<IProvider>(p => ({
  id: p.id,
  name: p.name,
  createdAt: p.created_at
}));
